<script setup lang="ts">
import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";

import { getDownloadUrl } from "@/api/client";

const props = defineProps<{ fileId: string }>();

// Presigned URLs are short-lived + per-file; cache by id so a gallery doesn't
// re-fetch the same photo on re-render.
const { data: url } = useQuery({
  queryKey: ["file-url", computed(() => props.fileId)],
  queryFn: () => getDownloadUrl(props.fileId),
  staleTime: 10 * 60 * 1000,
});

function open(): void {
  if (url.value) window.open(url.value, "_blank");
}
</script>

<template>
  <button
    type="button"
    class="aspect-square overflow-hidden rounded-md border border-neutral-200 bg-neutral-100"
    :title="url ? 'Open full size' : 'Loading…'"
    @click="open"
  >
    <img
      v-if="url"
      :src="url"
      alt="photo"
      class="h-full w-full object-cover transition hover:opacity-90"
    >
    <span
      v-else
      class="flex h-full w-full items-center justify-center text-xs text-neutral-400"
    >…</span>
  </button>
</template>
